import { DomainViewModel } from '@/view-models'
import { TOKEN } from '@/utils'
import { DomainHTTP } from '@/http'
import { DomainConfigView } from '@/views'

export const setupDomain = (): void => {
  const domainRegistrationWidgets = document.querySelectorAll<HTMLElement>(
    '.js-domain-registration-widget'
  )

  const domainHttp = new DomainHTTP()
  const domainViewModel = new DomainViewModel(domainHttp)

  domainRegistrationWidgets.forEach((domainWidget) => {
    if (!TOKEN) {
      throw new Error("Domain Setup: Token isn't set")
    }

    const domainModel = domainViewModel.makeModel(domainWidget, TOKEN)
    domainViewModel.addModel(domainModel)
    new DomainConfigView(domainWidget, domainModel, domainViewModel)
  })
}
